import { toPositiveOptionId } from '@/utils/optionValues';

export const saleModalWatch = {
  show(visible) {
    if (visible) {
      this.handleOpen();
      return;
    }

    this.clearTaxPreviewDebounce();
    this.resetState();
    this.v$.$reset();
  },
  initialData() {
    if (!this.show || !this.isEditMode) {
      return;
    }

    this.applyInitialDataToForm();
  },
  'form.subtotal': {
    handler() {
      this.syncAgencyAmount();
      this.scheduleTaxPreview();
    },
  },
  'form.mediaAmount': {
    handler() {
      this.syncAgencyAmount();
    },
  },
  'form.service': {
    handler(serviceOption) {
      if (this.consecutiveType !== 'services') {
        return;
      }

      this.loadSuggestedSaleCode(serviceOption);
    },
  },
  'form.customer': {
    handler(nextCustomer, previousCustomer) {
      if (!this.show) {
        return;
      }

      const nextCustomerId = toPositiveOptionId(nextCustomer);
      const previousCustomerId = toPositiveOptionId(previousCustomer);

      if (nextCustomerId === previousCustomerId) {
        return;
      }

      this.loadQuoteCatalogsForCustomer(nextCustomerId);
    },
  },
  'form.taxType'() {
    this.scheduleTaxPreview();
  },
  'form.taxes': {
    deep: true,
    handler() {
      this.scheduleTaxPreview();
    },
  },
  'form.taxGroup'() {
    this.scheduleTaxPreview();
  },
  'form.withoutTaxes'() {
    this.scheduleTaxPreview();
  },
};
